exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,sans-serif;\n    font-size: 15px;\n    background-color: #f2f3f5;\n    margin: 0;\n    padding-top: 55px;\n    overflow-y: scroll;\n}\n\na,body {\n    color: #34495e;\n}\n\na {\n    text-decoration: none;\n    word-break: break-all;\n}\n\nimg {\n  max-width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 158
// module chunks = 2